import updateCart from './update-popup-cart.js';
import { postData } from './fetch';

window.addEventListener('load', () => {
  const setPopupWrapper = document.querySelectorAll('.set-popup-wrapper');
  const successPopup = document.querySelector('.success-popup');
  const productPopup = document.querySelector('.product-popup');

  if (setPopupWrapper) {
    [].forEach.call(setPopupWrapper, (popup) => {
      const addModifierButton = popup.querySelectorAll('.add-modifier');
      const countButtons = popup.querySelectorAll('.modifier-count');
      const setItems = popup.querySelectorAll('.set-item.required');
      const popupSetItems = popup.querySelectorAll('.set-item');
      const setBuyBtn = popup.querySelector('.set-buy-btn');

      let activeSetItems = popup.querySelectorAll('.set-item.active').length;
      let modifiers = [];

      if (addModifierButton) {
        [].forEach.call(addModifierButton, (btn) => {
          btn.addEventListener('click', () => {
            let typeProductsSum = 0;

            const parentElement = btn.closest('.modifier-control');
            const { id } = btn.dataset;
            const groupId = btn.dataset.type;
            const minAmount = btn.dataset.minamount;

            const setItem = popup.querySelector(`.set-item.item-${groupId}`);
            const requiredSetItem = popup.querySelector(
              `.set-item.required.item-${groupId}`,
            );

            const productItem = {
              groupId,
              items: [
                {
                  id,
                  quantity: parseInt(minAmount, 10),
                },
              ],
            };

            const currentProduct = modifiers.find(
              (modifier) => modifier.groupId === groupId,
            );

            if (currentProduct) {
              const item = {
                id,
                quantity: parseInt(minAmount, 10),
              };

              currentProduct.items.push(item);

              modifiers = modifiers.filter(
                (modifier) => modifier.groupId !== groupId,
              );
              modifiers.push(currentProduct);
            } else {
              modifiers.push(productItem);
            }

            [].forEach.call(modifiers, (modifier) => {
              if (modifier.groupId === groupId) {
                modifier.items.forEach((i) => {
                  typeProductsSum = typeProductsSum + parseInt(i.quantity, 10);
                });
              }
            });

            if (setItem) {
              const countElement = setItem.querySelector('.count');

              if (countElement) {
                countElement.textContent = typeProductsSum;
              }
            }

            if (
              typeProductsSum >=
                parseInt(popup.getAttribute(`data-${groupId}`), 10) &&
              setItem
            ) {
              if (
                requiredSetItem &&
                !requiredSetItem.classList.contains('active')
              ) {
                activeSetItems = activeSetItems + 1;
              }

              setItem.classList.add('active');

              if (activeSetItems === setItems.length) {
                setBuyBtn.classList.remove('disabled');
              }
            }

            if (
              typeProductsSum ===
              parseInt(popup.getAttribute(`data-max-${groupId}`), 10)
            ) {
              const currenTypeAddModifierButton = popup.querySelectorAll(
                `.add-modifier[data-type="${groupId}"]`,
              );
              const currentCountButton = popup.querySelectorAll(
                `.modifier-count[data-type="${groupId}"]`,
              );

              if (currenTypeAddModifierButton) {
                [].forEach.call(currenTypeAddModifierButton, (button) =>
                  button.classList.add('disabled'),
                );
              }

              if (currentCountButton) {
                [].forEach.call(currentCountButton, (wrapper) => {
                  const plusButton = wrapper.querySelector('.plus');

                  if (plusButton) {
                    plusButton.classList.add('disabled');
                  }
                });
              }
            }

            if (parentElement) {
              const countButton = parentElement.querySelector(
                '.modifier-count',
              );

              if (countButton) {
                btn.classList.add('hidden');
                countButton.classList.add('visible');
              }
            }
          });
        });
      }

      if (countButtons) {
        [].forEach.call(countButtons, (wrapper) => {
          const countInput = wrapper.querySelector('.count-input');
          const buttonMinus = wrapper.querySelector('.minus');
          const buttonPlus = wrapper.querySelector('.plus');
          const parentElement = wrapper.closest('.modifier-control');

          const { id } = wrapper.dataset;
          const groupId = wrapper.dataset.type;
          const max = countInput.getAttribute('max');

          const setItem = popup.querySelector(`.set-item.item-${groupId}`);
          const requiredSetItem = popup.querySelector(
            `.set-item.required.item-${groupId}`,
          );

          let sum = 0;

          if (buttonMinus) {
            buttonMinus.addEventListener('click', () => {
              const currentProduct = modifiers.find(
                (modifier) => modifier.groupId === groupId,
              );

              let count = parseInt(countInput.value, 10);

              count -= 1;
              countInput.value = count;

              if (count === 0) {
                wrapper.classList.remove('visible');
                countInput.value = 1;

                if (currentProduct) {
                  currentProduct.items = currentProduct.items.filter(
                    (i) => i.id !== id,
                  );
                  modifiers = modifiers.filter(
                    (modifier) => modifier.groupId !== groupId,
                  );

                  if (currentProduct.items.length) {
                    modifiers.push(currentProduct);
                  }
                }

                if (parentElement) {
                  const addButton = parentElement.querySelector(
                    '.add-modifier',
                  );

                  if (addButton) {
                    addButton.classList.remove('hidden');
                  }
                }
              } else {
                const item = {
                  id,
                  quantity: count,
                };

                if (currentProduct) {
                  currentProduct.items = currentProduct.items.filter(
                    (i) => i.id !== id,
                  );
                  currentProduct.items.push(item);

                  modifiers = modifiers.filter(
                    (modifier) => modifier.groupId !== groupId,
                  );
                  modifiers.push(currentProduct);
                }

                if (
                  count < parseInt(max, 10) &&
                  buttonPlus.classList.contains('disabled')
                ) {
                  buttonPlus.classList.remove('disabled');
                }
              }

              if (setItem) {
                const countElement = setItem.querySelector('.count');

                if (countElement) {
                  sum = parseInt(countElement.innerHTML, 10) - 1;

                  if (sum > 0) {
                    countElement.textContent = sum;
                  } else {
                    countElement.textContent = '';
                  }
                }
              }

              if (
                (sum < parseInt(popup.getAttribute(`data-${groupId}`), 10) ||
                  sum === 0) &&
                setItem
              ) {
                if (setItem.classList.contains('active')) {
                  setItem.classList.remove('active');

                  activeSetItems = activeSetItems - 1;

                  if (activeSetItems < setItems.length) {
                    setBuyBtn.classList.add('disabled');
                  }
                }
              }

              if (
                sum < parseInt(popup.getAttribute(`data-max-${groupId}`), 10)
              ) {
                const currenTypeAddModifierButton = popup.querySelectorAll(
                  `.add-modifier[data-type="${groupId}"]`,
                );
                const currentCountButton = popup.querySelectorAll(
                  `.modifier-count[data-type="${groupId}"]`,
                );

                if (currenTypeAddModifierButton) {
                  [].forEach.call(currenTypeAddModifierButton, (button) =>
                    button.classList.remove('disabled'),
                  );
                }

                if (currentCountButton) {
                  [].forEach.call(currentCountButton, (wrapper) => {
                    const currentPlusButton = wrapper.querySelector('.plus');
                    const currentCountInput = wrapper.querySelector(
                      '.count-input',
                    );
                    const currentMax = currentCountInput.getAttribute('max');

                    if (
                      currentPlusButton &&
                      parseInt(currentCountInput.value, 10) <
                        parseInt(currentMax, 10)
                    ) {
                      currentPlusButton.classList.remove('disabled');
                    }
                  });
                }
              }
            });
          }

          if (buttonPlus) {
            buttonPlus.addEventListener('click', () => {
              let count = parseInt(countInput.value, 10);

              if (count < parseInt(max, 10)) {
                count += 1;
                countInput.value = count;

                const currentProduct = modifiers.find(
                  (modifier) => modifier.groupId === groupId,
                );

                if (currentProduct) {
                  const item = {
                    id,
                    quantity: count,
                  };

                  currentProduct.items = currentProduct.items.filter(
                    (i) => i.id !== id,
                  );
                  currentProduct.items.push(item);

                  modifiers = modifiers.filter(
                    (modifier) => modifier.groupId !== groupId,
                  );
                  modifiers.push(currentProduct);
                }

                if (setItem) {
                  const countElement = setItem.querySelector('.count');

                  if (countElement) {
                    sum = parseInt(countElement.innerHTML, 10) + 1;
                    countElement.textContent = sum;
                  }
                }

                if (
                  sum === parseInt(popup.getAttribute(`data-${groupId}`), 10) &&
                  setItem
                ) {
                  if (
                    requiredSetItem &&
                    !requiredSetItem.classList.contains('active')
                  ) {
                    activeSetItems = activeSetItems + 1;
                  }

                  setItem.classList.add('active');

                  if (activeSetItems === setItems.length) {
                    setBuyBtn.classList.remove('disabled');
                  }
                }

                if (
                  sum ===
                  parseInt(popup.getAttribute(`data-max-${groupId}`), 10)
                ) {
                  const currenTypeAddModifierButton = popup.querySelectorAll(
                    `.add-modifier[data-type="${groupId}"]`,
                  );
                  const currentCountButton = popup.querySelectorAll(
                    `.modifier-count[data-type="${groupId}"]`,
                  );

                  if (currenTypeAddModifierButton) {
                    [].forEach.call(currenTypeAddModifierButton, (button) =>
                      button.classList.add('disabled'),
                    );
                  }

                  if (currentCountButton) {
                    [].forEach.call(currentCountButton, (wrapper) => {
                      const plusButton = wrapper.querySelector('.plus');

                      if (plusButton) {
                        plusButton.classList.add('disabled');
                      }
                    });
                  }
                }
              }

              if (count === parseInt(max, 10)) {
                buttonPlus.classList.add('disabled');
              }
            });
          }
        });
      }

      if (setBuyBtn) {
        setBuyBtn.addEventListener('click', async () => {
          const body = {
            id: setBuyBtn.dataset.id,
            quantity: 1,
            modifiers: JSON.stringify(modifiers),
          };

          const { price } = setBuyBtn.dataset;

          setBuyBtn.textContent = 'Загрузка...';
          setBuyBtn.classList.add('disabled');

          const response = await postData("/cart", body);

          if (response) {
            if (response.statusCode === 200) {
              setBuyBtn.textContent = 'Добавлено';

              if (successPopup) {
                productPopup.classList.add('hidden');
                successPopup.classList.add('visible');
              }

              setTimeout(() => {
                document.body.style.overflow = 'auto';
                popup.classList.remove('active');

                if (successPopup) {
                  successPopup.classList.remove('visible');
                }

                if (countButtons) {
                  [].forEach.call(countButtons, (modifier) => {
                    const plusButton = modifier.querySelector('.plus');
                    const countInput = modifier.querySelector(
                      '.count-input',
                    );

                    modifier.classList.remove('visible');

                    if (plusButton) {
                      const maxAmount = plusButton.dataset.maxamount;

                      if (maxAmount > 1) {
                        plusButton.classList.remove('disabled');
                      }
                    }

                    if (countInput) {
                      countInput.value = 1;
                    }
                  });
                }

                if (addModifierButton) {
                  [].forEach.call(addModifierButton, (btn) => {
                    btn.classList.remove('disabled');
                    btn.classList.remove('hidden');
                  });
                }

                if (popupSetItems) {
                  [].forEach.call(popupSetItems, (item) => {
                    item.classList.remove('active');

                    const count = item.querySelector('.count');

                    if (count) {
                      count.textContent = '';
                    }
                  });
                }

                setBuyBtn.textContent = `В корзину за ${price} ₽`;
                activeSetItems = popup.querySelectorAll('.set-item.active')
                  .length;
                modifiers = [];
              }, 2000);

              updateCart(response.data, response.data.additional);
            } else {
              setBuyBtn.classList.remove('disabled');
              setBuyBtn.textContent = `В корзину за ${price} ₽`;
            }
          }
        });
      }
    });
  }
});
